export default __webpack_public_path__ + "static/media/logo_round.3cec55aa.png";